import React, { useEffect, useState } from "react";
import MainPages from "./MainPages";
import { withErrorBoundary, useErrorBoundary } from "react-use-error-boundary";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./Pages/ScrollToTop";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
);
const App = withErrorBoundary(({ children }) => {
  const [isAdsShown, setIsAdsShown] = useState(true);
  const [error, resetError] = useErrorBoundary(
    // You can optionally log the error to an error reporting service
    (error, errorInfo) => {
      toast.error(errorInfo);
    }
  );

  useEffect(() => {
    if (window.localStorage.getItem("ads-shown")) {
      setIsAdsShown(true);
    } else {
      setIsAdsShown(false);
    }
  }, []);
  return (
    <>
      <MainPages />
      <ScrollToTop />
      <ToastContainer
        position="bottom-right"
        theme={"colored"}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
});

export default App;
